import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { maskCNPJ, maskCPF } from 'util/masks'
import { createDocument, getDocument, getDocumentList, updateDocument } from './redux/actions'

type DocumentOpts = { person?: number, title?: boolean, fetchDocuments?: boolean }

const initialState = { type: '', value: '' }
const DocumentForm: React.FC<DocumentOpts> = ({ person, title = true, fetchDocuments = true }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const inpRef = useRef<HTMLInputElement>(null)

  const [isFetching, setFetching] = useState(false)
  const [form, setForm] = useState(initialState)
  const isFormValid = !!(form.type && form.value)

  const { personId: routePerson, documentId: id } = useParams<{ personId: string, documentId: string }>()

  const personId = routePerson || person

  function handleClear (): void {
    setForm(initialState)
    history.push(person ? '/panel/profile' : `/panel/person/${personId}/document`)
  }

  async function handleForm (e: React.FormEvent): Promise<void> {
    e.preventDefault()
    setFetching(true)
    if (personId && id) {
      await updateDocument(personId, id, form)(dispatch)
    } else if (personId) {
      await createDocument(personId, form)(dispatch).then(res => {
        if (res?.status === 'success') {
          setForm(initialState)
        }
        return res
      })
    }
    setFetching(false)
  }

  useEffect(() => {
    if (personId && fetchDocuments) {
      getDocumentList(personId)(dispatch)
    }
  }, [dispatch, personId, fetchDocuments])

  useEffect(() => {
    if (personId && id) {
      getDocument(personId, id)(dispatch).then((res) => {
        if (res?.status === 'success' && res?.data) {
          setForm({ type: res.data.type, value: res.data.value })
          inpRef.current?.focus()
        }
      })
    } else {
      setForm(initialState)
    }
  }, [dispatch, personId, id, inpRef])

  return (
    <form className="row justify-start form-responsive" onSubmit={handleForm}>
      {
        title && (id ? <h2>Edição de Documento</h2> : <h2>Cadastro de Documento</h2>)
      }

      <div className="form-control">
        <label>Tipo de Documento</label>
        <select
          value={form.type}
          onChange={(e): void => setForm({ ...form, type: e.target.value })}
          required
        >
          <option value="PP">Passaporte</option>
          <option value="DL">CNH</option>
          <option value="ID">RG</option>
          <option value="TIN">CPF</option>
          <option value="BIN">CNPJ</option>
          <option value="EIN">I.E</option>
        </select>
      </div>
      <div className="form-control">
        <label>Número do Documento</label>
        <input
          type="text"
          value={form.value}
          ref={inpRef}
          onChange={(e): void => {
            let value = e.target.value
            switch (form.type) {
              case 'TIN': value = maskCPF(e.target.value); break
              case 'BIN': value = maskCNPJ(e.target.value); break
              case 'DL': value = e.target.value.replace(/[\D]/g, ''); break
              case 'ID': value = e.target.value.replace(/[\D]/g, ''); break
            }
            setForm({ ...form, value })
          }}
          required
        />
      </div>
      <div className="form-control justify-end responsive-btn">
        <span
          onClick={handleClear}
          style={{ width: 300 }}
          className="button secondary margin-right-8"
        >
          Limpar
        </span>
        <button className="primary" style={{ width: 300 }} disabled={!isFormValid || isFetching}>
          {isFetching ? 'Processando...' : (id ? 'Atualizar' : 'Cadastrar')}
        </button>
      </div>
    </form>
  )
}

export default DocumentForm
